import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useGetBillRequestsForAirwallexBatchPayment } from 'shared/data/webApp/v1';

import { getAirwallexContext } from '../../../../../selectors/airwallex/airwallexSelectors';
import { mapAirwallexXeroBillInvoiceRequests } from '../../XeroAirwallexBatchPaymentForm.helpers';
import { UseBillsForBatchPaymentData } from './XeroAirwallexBatchPaymentFormContent.types';

export const useBillsForBatchPaymentData = ({
    companyId,
    requestId,
    companyCurrency,
    filterTransfer,
    enabled,
}: UseBillsForBatchPaymentData) => {
    const airwallexContext = useSelector(getAirwallexContext);

    const { data, isLoading } = useGetBillRequestsForAirwallexBatchPayment(
        {
            query: { companyId, airwallexXeroBatchPaymentRequestId: requestId, ...filterTransfer },
        },
        { enabled }
    );

    const mappedData = useMemo(
        () =>
            mapAirwallexXeroBillInvoiceRequests(
                data?.items || [],
                airwallexContext.currencies || [],
                companyCurrency,
                airwallexContext.paymentFees || []
            ),
        [airwallexContext.currencies, airwallexContext.paymentFees, companyCurrency, data?.items]
    );

    return {
        billsForBatchPaymentData: mappedData,
        billsForBatchPaymentLoading: isLoading,
    };
};
